<template>
    <small
        v-if="message"
        :id="id"
        :class="errorClass"
        :style="styleDisplay"
    >
        {{ message }}
    </small>
</template>

<script setup>
import { computed } from "vue";
const props = defineProps({
    id: { type: String, default: null },
    message: { type: String, default: '' },
    bootstrap: { type: Boolean, default: false }
})

const errorClass = computed(() => {
    return props.bootstrap
        ? 'invalid-feedback text-danger mb-2'
        : 'text-red-600 text-sm mt-1';
})

const styleDisplay = computed(() => {
    if (props.bootstrap && !props.message) {
        return "display: none;";
    }
    return '';
})
</script>
